import { FC } from "react";

import { isoToDate } from "shared/utils";
import { MutedDarkText, MutedText } from "shared/styles";
import { IEvent } from "Bands/types";

import { StyledCalendarListDate } from "./styles";

type PartialEvent = Pick<IEvent, "date">;

interface CalendarListDateProps extends PartialEvent {
  showFullDate?: boolean;
}

export const CalendarListDate: FC<CalendarListDateProps> = ({
  date,
  showFullDate,
}) => {
  return (
    <StyledCalendarListDate>
      <MutedText style={{ whiteSpace: "nowrap" }}>
        {isoToDate(date).day}
        {showFullDate && `/${isoToDate(date).month}`}
      </MutedText>
      <MutedDarkText>{isoToDate(date).shortWeekday}</MutedDarkText>
    </StyledCalendarListDate>
  );
};
